(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-play/assets/javascripts/ball-row-play-vikinglotto.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-play/assets/javascripts/ball-row-play-vikinglotto.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.play = svs.tur.ball.row.play || {};
class Vikinglotto extends svs.tur.ball.row.play.Default {
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$numbers = _ref.numbers,
      numbers = _ref$numbers === void 0 ? 6 : _ref$numbers,
      _ref$extraNumbers = _ref.extraNumbers,
      extraNumbers = _ref$extraNumbers === void 0 ? 1 : _ref$extraNumbers,
      _ref$isSystem = _ref.isSystem,
      isSystem = _ref$isSystem === void 0 ? false : _ref$isSystem,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 200 : _ref$size,
      isValid = _ref.isValid,
      isActive = _ref.isActive,
      isEmpty = _ref.isEmpty;
    const _numbers = isSystem ? 0 : numbers,
      _extraNumbers = isSystem ? 0 : extraNumbers;
    const row = new svs.tur.ball.row.Vikinglotto({
      numbers: _numbers,
      extraNumbers: _extraNumbers,
      size
    });
    super({
      row,
      _numbers,
      _extraNumbers,
      isSystem,
      size,
      isValid,
      isActive,
      isEmpty
    });
  }
  classNames() {
    return ['ball-row-play-vikinglotto'];
  }
}
svs.tur.ball.row.play.Vikinglotto = Vikinglotto;

 })(window);